import { RootState } from 'app/store';
import DebugToggleTable from 'features/internal/debug-toggle/debug-toggle-table';
import { allDebugToggles } from 'features/internal/internal-settings.slice';
import { FC } from 'react';
import { useSelector } from 'react-redux';

export const InternalPage: FC = () => {
  const debugToggles = useSelector((state: RootState) =>
    allDebugToggles(state)
  );

  return (
    <>
      <DebugToggleTable debugToggles={debugToggles} />
    </>
  );
};
